import React, { Component } from 'react';
import cx from 'classnames';
import { SketchPicker } from 'react-color';
import { WRAPPER } from '../styles/colorPicker';
import Button from '../../Button';













class ColorPicker extends Component {
  static defaultProps = {
    initialValue: { hex: '000000', label: '' }
  };

  constructor(props) {
    super(props);

    this.state = {
      hex: props.initialValue.hex
    };
  }

  handleColorChange = ({ hex }) => {
    const { onSaveColor, withHash } = this.props;
    if (hex === 'TRANSPARENT') {
      onSaveColor({ hex });

      this.setState({ hex });
    } else {
      const hexWithoutHash = hex.substring(1, hex.length);

      this.setState({ hex: hexWithoutHash });

      onSaveColor({ hex: withHash ? hex : hexWithoutHash });
    }
  };

  handleTransparentColor = () => {
    this.handleColorChange({ hex: 'TRANSPARENT' });
  };

  render() {
    const { hex } = this.state;
    const { presetColors = [], transparentButton = false } = this.props;
    return (
      <div className={cx('color-picker', WRAPPER)}>
        <SketchPicker
          disableAlpha
          color={hex}
          onChangeComplete={this.handleColorChange}
          presetColors={presetColors} />

        {transparentButton &&
        <Button onClick={this.handleTransparentColor}>Set to transparent</Button>}

      </div>);

  }
}

export default ColorPicker;